<template>
  <div class="card">
    <div class="card-title">
      {{ label }}
    </div>
    <div class="card-actions"  v-if="$slots.actions">
      <slot name="actions">
      </slot>
    </div>
    <slot></slot>
  </div>
</template>


<script>
export default {
  props: {
    label: String,
  },
}
</script>



  <style scoped>
    .card {
        border: 3px solid gray;
        border-radius: 8px;
        padding: 5px;
    }
    .card-title {
        font-size: 14px;
        font-weight: 600;
        color: black;
        background: white;
        width: fit-content;
        margin-top: -20px;
        margin-bottom: 10px;
        margin-right: 12px;
        padding: 5px 18px;
        border: 2px solid black;
        border-radius: 10px;
    }
    .card-actions {
      color: black;
      background: white;
      width: fit-content;
      margin-top: -41px;
      border: 2px dashed black;
      border-radius: 10px;
      position: absolute;
      left: 42px;
    }
  </style>
  